module.exports = __webpack_public_path__ + "img/9788996995982.dac5f61c.jpg";